export default __webpack_public_path__ + "static/media/happy_chicekns.f79a9102.jpg";